// extracted by mini-css-extract-plugin
export default {"main":"imperfeito_main__wFmSz","title":"imperfeito_title__ek3uC"};